import { useLocation } from 'react-router';
import { resolveAnalyticsContext } from './routeMap';

/**
 * Automatically detects the page context from the current route
 * and generates appropriate modal/form types for analytics
 */
export const useAnalyticsContext = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const pageContext = resolveAnalyticsContext(pathname);

  // Generate modal and form types based on page context
  const getModalType = (defaultType?: string): string => {
    if (defaultType && defaultType !== 'generic-create') {
      return defaultType;
    }
    return pageContext;
  };

  const getFormType = (defaultType?: string): string => {
    if (defaultType && defaultType !== 'generic-form') {
      return defaultType;
    }
    return pageContext;
  };

  return {
    pageContext,
    getModalType,
    getFormType,
    pathname,
  };
};
